<script setup>
const props = defineProps({
	timeArray: Array,
});

const selectedTime = defineModel('selectedTime');
</script>

<template>
	<div class="time-picker-wr">
		<div>
			<div class="time-picker__header">Выберите время</div>
			<div class="time-picker__grid">
				<div
					class="time-picker__item"
					v-if="timeArray.length"
					v-for="(item, id) in timeArray"
					:key="id"
				>
					<input
						class="time-picker__input"
						type="radio"
						:id="`time-picker__input-${id}`"
						:value="item"
						v-model="selectedTime"
					>
					<label 
						class="time-picker__label" 
						:for="`time-picker__input-${id}`"
						:class="{ 'time-picker__label--checked': selectedTime === item }"
					>
						{{ item }}
					</label>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang='scss'>
.time-picker-wr { margin-top: 30px }

.time-picker__header { text-align: center }

.time-picker__grid {
	margin-block: 12px 16px;
	display: flex;
	gap: 8px;
	flex-wrap: wrap;

	input { display: none }
}

.time-picker__label {
	width: 63.5px;
	height: 38px;
	display: grid;
	cursor: pointer;
	place-items: center;
	border-radius: 8px;
	background-color: #F9F9F9;
	font-family: 'Inter';
	font-size: 14px;
	user-select: none;

	&.time-picker__label--checked {
		background-color: $yellow;
		color: #FFF;
	}
}

.time-picker__custom-time {
	width: fit-content;
	display: flex;
	cursor: pointer;
	align-items: center;
	gap: 10px;
	user-select: none;
	font-size: 14px;
}

.time-picker__apply-btn {
	width: 100%;
	height: 48px;
	margin-top: 24px;
	background-color: $yellow;
	border-radius: 12px;
	font-family: 'Raleway';
	font-weight: 600;
	color: #FFF;
}
</style>